import { render, staticRenderFns } from "./ApisLayout.vue?vue&type=template&id=468deb0a&scoped=true&"
import script from "./ApisLayout.vue?vue&type=script&lang=js&"
export * from "./ApisLayout.vue?vue&type=script&lang=js&"
import style0 from "./ApisLayout.vue?vue&type=style&index=0&id=468deb0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468deb0a",
  null
  
)

export default component.exports